import z from "zod";
import { newPasswordZodField } from "./password-field-schema";

export const resetPasswordSchema = z
  .object({
    newPassword: newPasswordZodField,
    confirmPassword: z.string(),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Passwords must match",
    path: ["confirmPassword"],
  });

export type ResetPasswordFormSchema = z.infer<typeof resetPasswordSchema>;
